const relativeLink = (url: string, extraParams?: Record<string, string | number>) => {
  let urlObj: URL;
  try {
    urlObj = new URL(url);
    extraParams &&
      Object.keys(extraParams).forEach((key) => {
        urlObj.searchParams.set(key, String(extraParams?.[key]));
      });
  } catch (e) {
    return url;
  }
  return `${urlObj.pathname}${urlObj.search}`;
};

export default relativeLink;
